<template>
  <div
    :class="['modal', 'custom-modal', 'fade', { show: show }]"
    :style="{ display: show ? 'block' : 'none' }"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">
            {{
              isEditMode ? "Sửa Cột " + editableColumn.title : "Thêm Cột Mới"
            }}
          </h4>
          <button type="button" class="close" @click="closeModal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label>Tên Cột <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                v-model="editableColumn.title"
                required
              />
            </div>
            <div class="form-group">
              <label>Trạng thái cột</label>
              <select
                class="form-control"
                v-model="editableColumn.trangThaiCauHinhCot"
              >
                <option :value="null">Không</option>
                <option value="HOANTHANH">Hoàn thành</option>
              </select>
            </div>
            <div class="m-t-20 text-center">
              <button type="submit" class="btn btn-primary btn-lg ml-2">
                Lưu Thay Đổi
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script setup>
import { onUnmounted } from "vue";
import { ref, watch, computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  columnData: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(["close", "save"]);

const editableColumn = ref({});

const availableColors = ref([
  { value: "kanban-primary", class: "board-primary" },
  { value: "kanban-success", class: "board-success" },
  { value: "kanban-info", class: "board-info" },
  { value: "kanban-purple", class: "board-purple" },
  { value: "kanban-warning", class: "board-warning" },
  { value: "kanban-danger", class: "board-danger" },
]);

// Computed property để xác định chế độ 'add' hay 'edit'
const isEditMode = computed(() => !!(props.columnData && props.columnData.id));

// không scroll body khi mở modal
watch(
  () => props.show,
  (newVal) => {
    if (newVal) {
      // Khi modal mở, thêm class để chặn cuộn
      document.body.classList.add("modal-open");
    } else {
      // Khi modal đóng, xóa class để cho phép cuộn lại
      document.body.classList.remove("modal-open");
    }
  }
);

// Đảm bảo class được xóa nếu component bị hủy đột ngột
onUnmounted(() => {
  document.body.classList.remove("modal-open");
});

// Sử dụng watch để cập nhật form khi prop thay đổi
watch(
  () => props.show,
  (newVal) => {
    if (newVal) {
      if (isEditMode.value) {
        // Chế độ Edit: Copy dữ liệu để tránh thay đổi trực tiếp prop
        editableColumn.value = JSON.parse(JSON.stringify(props.columnData));
      } else {
        // Chế độ Add: Reset form về trạng thái mặc định
        editableColumn.value = {
          title: "",
          cssClass: "kanban-primary",
          description: "",
          tasks: [],
        };
      }
    }
  }
);

const closeModal = () => {
  emit("close");
};

const handleSubmit = () => {
  if (!editableColumn.value.title.trim()) {
    alert("Tên cột không được để trống!");
    return;
  }
  emit("save", editableColumn.value);
  closeModal();
};
</script>

<style scoped>
/* CSS cho modal, đặc biệt là phần hiển thị show/hide */
body.modal-open {
  overflow: hidden;
}
.modal.show {
  display: block;
}
</style>
